import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

class UserService {
  /**
   * Get user information function
   */
  getUserInfo(parameter, id, courseId) {
    // console.log("call on: ", parameter, id, courseId)
    try {
      return axios.post(
        SERVER_URL + "husibuechapp/" + parameter,
        !courseId ? { id: id } : { id: id, course_id: courseId },
        {
          headers: authHeader(),
        },
      );
    } catch (e) {
      console.log("We had a problem with the database query: ", e);
      return [];
    }
  }
  /**
   * Update user information function
   */
  updateUser(type, JsonObject, userId) {
    try {
      // console.log("json,", JsonObject)
      return axios.post(
        SERVER_URL + "ksbhub/userupdate/" + type + "/" + userId,
        JsonObject,
        { headers: authHeader() },
      );
    } catch (error) {
      console.log(error);
      return error;
    }
  }
  /**
   * Delete functions
   */
  delete(type, deleteList, userId) {
    try {
      // console.log(assignmentJson)
      return axios.post(
        SERVER_URL + "delete/" + type + "/" + userId,
        deleteList,
        { headers: authHeader() },
      );
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  deleteUser(id) {
    console.log(id);
    try {
      return axios.get(SERVER_URL + "users/kill/" + id, {
        headers: authHeader(),
      });
    } catch (e) {
      return e;
    }
  }

  /**
   * Request password reset (send email)
   */
  requestPasswordReset(email) {
    try {
      return axios.post(SERVER_URL + "auth/request-password-reset", {
        email: email,
      });
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  resetPassword(userId, token, password) {
    return axios.post(SERVER_URL + "auth/reset-password", {
      userId,
      token,
      password,
    });
  }
}

export default new UserService();
